<div class="tw-pb-6 tw-pl-6">
  <p class="tw-text-xl" *ngIf="product === Product.PasswordManager">
    {{ "trialThankYou" | i18n: orgLabel }}
  </p>
  <p class="tw-text-xl" *ngIf="product === Product.SecretsManager">
    {{ "smFreeTrialThankYou" | i18n }}
  </p>
  <ul class="tw-list-disc">
    <li>
      <p>
        {{ "trialConfirmationEmail" | i18n }}
        <span class="tw-font-medium">{{ email }}</span
        >.
      </p>
    </li>
    <li *ngIf="trialLength > 0">
      <p>
        {{ "trialPaidInfoMessageSpecificTrialLength" | i18n: orgLabel : trialLength }}
      </p>
    </li>
  </ul>
</div>
